module.exports = __webpack_public_path__ + "img/Youtube-settings.63a3f51a.png";